// extracted by mini-css-extract-plugin
module.exports = {"m-map-message":"MapMessage_m-map-message__hYXD1","m-map-message__content":"MapMessage_m-map-message__content__3YQO-"};